<template>
  <div class="delivery-form">
    <el-form
      ref="form"
      v-loading="loading"
      :model="form"
      :rules="rules"
      label-width="120px"
      style="overflow: auto"
    >
      <div style="text-align: right">
        <el-button
          size="small"
          style="background: cornflowerblue; color: white; margin-right: 10px"
          :loading="printing"
          @click="print"
        >打印<span v-if="printing">中...</span></el-button>
        <el-button-export
          :url="downloadUrl"
          size="small"
          type="success"
        >下载</el-button-export>
      </div>
      <el-tabs v-model="activeName" type="card">
        <el-tab-pane label="详细信息" name="first">
          <el-table :data="form.entrys" height="100%">
            <el-table-column label="名称" prop="fName" />
            <el-table-column label="型号/规格" prop="fModel" />
            <el-table-column label="单位" prop="fUnit" />
            <el-table-column label="数量" prop="fQty" />
            <el-table-column label="单价" prop="fPrice_fh" />
            <el-table-column label="金额" prop="fTotal" />
            <el-table-column label="生产批号" prop="fBatchNo" />
            <el-table-column label="生产日期" prop="fDate_Sc" />
            <el-table-column label="失效日期" prop="expiryDate" />
            <el-table-column label="追溯号" prop="fRetroactiveNo" />

            <!-- <el-table-column label="注册号" prop="fRegisterNumber" />
            <el-table-column label="供应商" prop="fSupplier" /> -->
          </el-table>
        </el-tab-pane>
        <el-tab-pane label="物流信息" name="fourth">
          <el-form label-width="150px" class="wlinfo">
            <el-form-item label="快递公司">
              <el-input :value="form.fKdCompany" readonly />
            </el-form-item>
            <el-form-item label="物流单号">
              <el-input :value="form.fKdNumber" readonly />
              <el-link
                v-if="form.fKdNumberUrl"
                type="primary"
                :href="form.fKdNumberUrl"
                target="_blank"
                style="margin-left: 10px"
              >查询</el-link>
            </el-form-item>
            <el-form-item label="印章">
              <el-input :value="form.fSeal" readonly />
              <p>
                <img
                  v-if="form.fSealUrl"
                  :src="form.fSealUrl"
                  style="width: 150px"
                >
              </p>
            </el-form-item>
          </el-form>
        </el-tab-pane>
        <el-tab-pane label="单据流程" name="third">
          <el-table :data="form.procedureMessage" height="100%">
            <el-table-column label="流程步骤" prop="fName" />
            <el-table-column label="处理人" prop="fUserName" />
            <el-table-column label="状态" prop="fState" />
            <el-table-column
              label="日期"
              prop="fDate"
              :formatter="dateTimeFormat"
            />
            <el-table-column label="意见" prop="fOpinion" />
          </el-table>
        </el-tab-pane>
      </el-tabs>
      <iframe
        style="display: none"
      ><Print id="printVoucher" ref="printVoucher"></Print
        ></iframe>
    </el-form>
  </div>
</template>

<script>
import { Now, Today, DeepCopy } from '@assets/site'
import moment from 'moment'
// import Print from "../commonPrint/Print.vue";
import Print from './Print'

import printnb from '@plugins/vue-print-nb-printarea'

export default {
  components: {
    Print
  },
  data: function() {
    return {
      form: {
        procedureInfo: {},
        procedureMessage: [],
        entrys: []
      },

      rules: {},

      activeName: 'first',
      printing: false,

      saving: false,
      loading: false,
      isNew: false
    }
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      if (!vm.routePath || vm.routePath != to.fullPath) {
        vm.routePath = to.fullPath
        vm.refresh()
      }
    })
  },
  beforeRouteUpdate: function(to, from, next) {
    next()
    const vm = this
    vm.routePath = to.fullPath
    vm.refresh()
  },
  methods: {
    refresh: async function(fid) {
      const id = fid || +this.$route.params.id
      this.isNew = !id
      if (id == 0) {
        this.form = {
          procedureInfo: {},
          procedureMessage: [],
          entrys: []
        }
        return
      }

      this.loading = true
      const res = await this.$httpPost('BusinessManage/Delivery/GetDelivery', {
        fid: id
      }).finally(() => (this.loading = false))

      if (!res.isSuccess) {
        this.$message.error(res.message)
        return
      }

      this.form = res.datalist
    },
    print: async function() {
      this.printing = true
      const success = await this.$refs.printVoucher.refresh(this.form.fid)
      if (!success) {
        this.printing = false
        return
      }

      // https://www.npmjs.com/package/vue-print-nb
      new printnb({
        ids: 'printVoucher', // * 局部打印必传入id
        standard: '', // 文档类型，默认是html5，可选 html5，loose，strict
        extraHead: '', // 附加在head标签上的额外标签,使用逗号分隔
        extraCss: '', // 额外的css连接，多个逗号分开
        popTitle: '', // title的标题
        endCallback() {
          // 调用打印之后的回调事件
        }
      })
      setTimeout(() => {
        this.printing = false
      }, 100)
    },
    downloadUrl: function() {
      return this.$buildDownloadUrl('Download/DeliveryDownload2', {
        fid: this.form.fid
      })
    },
    dateTimeFormat: function(row, column, cellValue) {
      const date = cellValue
      if (date == undefined || date == 'Invalid date') {
        return ''
      }
      return moment(date).format('YYYY-MM-DD HH:mm:ss')
    },
    dateFormat: function(row, column, cellValue) {
      const date = cellValue
      if (date == undefined || date == 'Invalid date') {
        return ''
      }
      return moment(date).format('YYYY-MM-DD')
    }
  }
}
</script>

<style lang="less">
.delivery-form {
  .el-tabs {
    .el-tabs__content {
      height: calc(100vh - 200px);
      .el-tab-pane {
        height: calc(100vh - 200px);
      }
    }
  }
}
</style>
<style lang="less" scoped>
.delivery-form {
  .wlinfo {
    .el-input,
    .el-select {
      width: 20%;
    }
  }
}
</style>
